var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"job-category-line-menu",attrs:{"data-testid":"row-actions"}},[_c(_setup.OrgObjectActionsMenu,{attrs:{"objectType":"job_category","status":_setup.normalizedStatus,"objectSpecificActions":_setup.objectSpecificActions},on:{"action":_setup.handleAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }